import React from 'react';
import Accordion from 'components/commercetools-ui/atoms/accordion';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import * as screensizes from 'helpers/utils/screensizes';
import { Reference } from 'types/reference';
import Image, { ImageProps } from 'frontastic/lib/image';
import Column, { FooterLink } from './atoms/column';
import FooterBottom from './footer-bottom';
import { useParams } from 'next/navigation';
import { localeMapping } from 'helpers/constants/localeMapping';

export interface FooterColumn {
  header?: string;
  links?: FooterLink[];
}
export interface Props {
  columns: FooterColumn[];
  logo?: any;
  socialMedia?: any;
  copyright?: any;
}

export interface SocialMedia {
  logo: string;
  reference: Reference;
}


//Change the footer menu links based on Locale (AU/NZ)
//In Caroma NZ we no need to show "Design & Planning"
const Footer: React.FC<Props> = ({ columns, logo, socialMedia, copyright }) => {
  const { locale } = useParams();
  const localeKey = localeMapping[locale];
  const gridClass = localeKey === 'en-NZ' ? 'grid-cols-4' : 'grid-cols-5';
  
  const [isBiggerThanTabletSize] = useMediaQuery(screensizes.mediumDesktop);
  return (
    <footer
      aria-labelledby="footer-heading"
      className="w-full bg-[#090909] py-48 px-24 md:px-28 lg:px-48 xl:px-60 2xl:px-80 xl:pb-60 xl:pt-80"
    >
      <div className="hidden w-full justify-between lg:flex ">
        <div className="h-200 w-350 lg:pr-32 3xl:pr-52 lg:h-150 lg:w-200  3xl:h-[200px] 2xl:w-[350px]">
          <Image src={logo?.url} alt={logo?.description} width={250} height={100} />
        </div>
        <div className={`grid w-full ${gridClass}`}>
          {columns?.map((column, index) => (
            <div key={index}>
              <Column
                header={column?.header}
                links={column?.links ?? []}
                className="flex flex-col items-center lg:items-start"
              />
            </div>
          ))}
        </div>
      </div>
      <ul className="flex flex-col lg:hidden lg:pt-20">
        <div className="mb-48 w-[12.125rem]">
          <Image src={logo?.url} alt={logo?.description} width={194} height={54.74} />
        </div>
        {columns?.map((column, index) => (
          <li key={index} className="">
            <Accordion
              variant="arrow"
              defaultOpen
              closedSectionTitle={column?.header ?? ''}
              openSectionTitle={column?.header}
              buttonClassName="h-48 text-18 font-medium text-neutral-100 text-neutral-150 border-b border-white"
              iconClassName="text-neutral-100"
            >
              <div className="mb-18 flex flex-row text-14" key={index}>
                <Column links={column?.links ?? []} className="px-0" />
              </div>
            </Accordion>
          </li>
        ))}
      </ul>
      <FooterBottom socialMedia={socialMedia} copyright={copyright} />
    </footer>
  );
}; 

//NZ commit
export default Footer;
